const BASE_URL = "/api";

export const apiService = async (
  endpoint,
  method = "GET",
  data = null,
  id = null
) => {
  const config = {
    method,
    headers: {
      "Content-Type": "application/json",
      // Authorization : `Bearer ${token}`
    },
  };

  if (data) {
    config.body = JSON.stringify(data);
  }
  const finalEndpoint = id ? `${endpoint}/${id}` : endpoint;

  try {
    const response = await fetch(`${BASE_URL}${finalEndpoint}`, config);
    const result = await response.json();
    return result;
  } catch (error) {
    console.error("API Hatası:", error);
    throw error;
  }
};
